import Resource from './Resource';

export enum ChangeType {
	NAME_CHANGED = 'NAME_CHANGED',
	NOTES_CHANGED = 'NOTES_CHANGED',
	PHONE_CHANGED = 'PHONE_CHANGED',
	FAX_CHANGED = 'FAX_CHANGED',
	WEBPAGE_CHANGED = 'WEBPAGE_CHANGED',
	ADDRESS_CHANGED = 'ADDRESS_CHANGED',
	ORG_NO_CHANGED = 'ORG_NO_CHANGED',
	COMPANY_FORM_CHANGED = 'COMPANY_FORM_CHANGED',
	STOCK_LIST_CHANGED = 'STOCK_LIST_CHANGED',
	SNI_CODE_CHANGED = 'SNI_CODE_CHANGED',
	PARENT_CHANGED = 'PARENT_CHANGED',
	OPERATIONAL_ACCOUNT_CHANGED = 'OPERATIONAL_ACCOUNT_CHANGED',
	ACTIVE_CHANGED = 'ACTIVE_CHANGED',
	IS_MONITORED_CHANGED = 'IS_MONITORED_CHANGED',
	DUNS_NO_CHANGED = 'DUNS_NO_CHANGED',
	CFAR_CHANGED = 'CFAR_CHANGED',
	CREDIT_RATING_CHANGED = 'CREDIT_RATING_CHANGED',
	PROSPECTING_CREDIT_RATING_CHANGED = 'PROSPECTING_CREDIT_RATING_CHANGED',
	TURNOVER_CHANGED = 'TURNOVER_CHANGED',
	PROFIT_CHANGED = 'PROFIT_CHANGED',
	NO_EMPLOYEES_CHANGED = 'NO_EMPLOYEES_CHANGED',
	FACEBOOK_CHANGED = 'FACEBOOK_CHANGED',
	TWITTER_CHANGED = 'TWITTER_CHANGED',
	LINKEDIN_CHANGED = 'LINKEDIN_CHANGED',
	SIC_CODE_CHANGED = 'SIC_CODE_CHANGED',
	NAICS_CODE_CHANGED = 'NAICS_CODE_CHANGED',
	UK_SIC_CODE_CHANGED = 'UK_SIC_CODE_CHANGED',
	NACE_CODE_CHANGED = 'NACE_CODE_CHANGED',
	ABOUT_CHANGED = 'ABOUT_CHANGED',
	JOURNEY_STEP_CHANGED = 'JOURNEY_STEP_CHANGED',
	PRICE_LIST_CHANGED = 'PRICE_LIST_CHANGED',
	ACCOUNT_MANAGER_CHANGED = 'ACCOUNT_MANAGER_CHANGED',
	CATEGORIES_CHANGED = 'CATEGORIES_CHANGED',
	CAMPAIGNS_CHANGED = 'CAMPAIGNS_CHANGED',
	CUSTOM_FIELD_CHANGED = 'CUSTOM_FIELD_CHANGED'
}

export type ClientChangeLogType = {
	modBy: { id: number; name: string; email?: string };
	changes: {
		oldValue: any;
		newValue: any;
		type: ChangeType;
		typeExtra?: string;
	}[];
	version: number;
	modDate: string;
	source?: {
		type: string;
		name?: string;
	};
};

class ClientChangeLog extends Resource {
	constructor() {
		super('clientChangeLog');
	}

	getClientChangeLog(clientId: number, limit: number, offset: number, filters: any) {
		return this._getRequest(clientId, {
			methodName: 'find',
			params: {
				limit,
				offset,
				...(filters ?? {})
			}
		}).then(res => {
			return {
				data: res.data.data as ClientChangeLogType[],
				metadata: res.data.metadata
			};
		});
	}
}

const resource = new ClientChangeLog();

export default resource;
